import React from 'react';
import {ThreadItem} from '../api/types';
import {isRuntimeTool} from '../artifacts';
import ApprovalRequestCard from './items/ApprovalRequestCard';
import AssistantMessageItemView from './items/AssistantMessageItemView';
import ReasoningItemView from './items/ReasoningItemView';
import RuntimeToolCallView from './items/RuntimeToolCallView';
import ToolCallItemView from './items/ToolCallItemView';
import UserMessageItemView from './items/UserMessageItemView';
import PageChangeItemView from './items/PageChangeItemView';

interface ThreadItemRendererProps {
    item: ThreadItem;
    pendingApprovalItemId: string | null;
    isApprovalSubmitting: boolean;
    onApprovalDecision: (
        approvalRequestItemId: string,
        approved: boolean
    ) => void;
}

const ThreadItemRenderer: React.FC<ThreadItemRendererProps> = ({
    item,
    pendingApprovalItemId,
    isApprovalSubmitting,
    onApprovalDecision
}) => {
    switch (item.kind) {
        case 'userMessage':
            return <UserMessageItemView item={item} />;

        case 'assistantMessage':
            return <AssistantMessageItemView item={item} />;

        case 'reasoning':
            return <ReasoningItemView item={item} />;

        case 'toolCall':
            // The code runtime family has its own card (code, output, files)
            return item.source === 'platform' &&
                isRuntimeTool(item.toolName) ? (
                <RuntimeToolCallView item={item} />
            ) : (
                <ToolCallItemView item={item} />
            );

        case 'approvalRequest':
            return (
                <ApprovalRequestCard
                    item={item}
                    isPending={item.id === pendingApprovalItemId}
                    isSubmitting={isApprovalSubmitting}
                    onDecision={approved =>
                        onApprovalDecision(item.id, approved)
                    }
                />
            );

        case 'approvalResponse':
            return null; // bookkeeping only - the request card shows the outcome

        case 'pageChange':
            return <PageChangeItemView item={item} />;

        default:
            return null;
    }
};

export default ThreadItemRenderer;
